module.exports = __webpack_public_path__ + "a87d5a7ba197707835cc51d62dd00f47.pdf";